import $ from 'jquery'

const quantityPlusMinus = () => {
    $(document).on('click', '.variant-card__add-to-cart .plus', function () {
        const $qty = $(this).closest('.quantity').find('.qty')
        const current = parseInt($qty.val()) || 1
        $qty.val(current + 1).trigger('change')
    })
    $(document).on('click', '.variant-card__add-to-cart .minus', function () {
        const $qty = $(this).closest('.quantity').find('.qty')
        const current = parseInt($qty.val()) || 1
        const min = parseInt($qty.attr('min')) || 1
        if (current > min) {
            $qty.val(current - 1).trigger('change')
        }
    })
}

$(document).ready(() => {
    try {
        quantityPlusMinus()
    } catch (error) {
        console.error('quantityPlusMinus error:', error)
    }
})
